import { Chip } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const DefaultParameterStatus = ({
  matchesScrapchefDefaults,
}: {
  matchesScrapchefDefaults: boolean | null;
}) => {
  const { t } = useTenantTranslation();
  if (matchesScrapchefDefaults === null) return null;
  return (
    <Chip
      label={t(
        matchesScrapchefDefaults ? "scrapChefDefaults" : "customerDefaults"
      )}
      size="small"
      variant="outlined"
    />
  );
};
